<template>
  <div id="resetPassword">

    <LoginTop></LoginTop>

    <div class="middle">
      <div class="middle-container">
        <div class="title">{{$t('reset_password.title')}}</div>
        <label for="txtResetPassword">{{$t('reset_password.new_password')}}</label>
        <input id="txtResetPassword" type="password" v-model="password">
        <label for="txtResetPasswordConfirmation">{{$t('reset_password.new_password_confirmation')}}</label>
        <input id="txtResetPasswordConfirmation" type="password" v-model="passwordRepeated">
        <button type="submit" class="btn btn-primary" @click="submitNewPassword">{{$t('save')}}</button>
      </div>
    </div>

    <LoginBottom></LoginBottom>

    <Modal
      name="password-validation-error"
      :title="$t('error.title')"
      :actions="[{name: $t('back'), action: 'close'}]">
      {{ validationErrorMessage }}
    </Modal>

    <Modal
      name="server-error"
      :title="$t('error.title')"
      :actions="[{name: $t('back'), action: 'close'}]">
      {{ serverErrorMessage }}
    </Modal>

  </div>
</template>

<script>

  import { Core } from '@/core/Core';
  import ActionMenu from "@/components/tools/ActionMenu.vue";
  import LoginTop from "@/components/login/Top.vue";
  import LoginBottom from "@/components/login/Bottom.vue";
  import { mapActions } from 'vuex';

  export default {

    name: "ResetPassword",

    components: { ActionMenu, LoginTop, LoginBottom },

    data() {
      return {
        password: "",
        passwordRepeated: "",
        validationErrorMessage: "",
        serverErrorMessage: ""
      }
    },

    methods: {

      ...mapActions(["resetPassword"]),

      async submitNewPassword() {
        let token = this.$route.query.token;
        if (this.password === "") {
          this.validationErrorMessage = this.$t("error.password_is_empty");
          this.$modal.show("password-validation-error");
          return;
        }
        if (this.password !== this.passwordRepeated) {
          this.validationErrorMessage = this.$t("error.repeated_password_is_different");
          this.$modal.show("password-validation-error");
          return;
        }

        this.$store.commit("showSpinner", true);
        let response = await this.resetPassword({token, password: this.password})
        if (response instanceof Core.Error) {
          if (response.status === 404) {
            this.serverErrorMessage = this.$t("error.reset_password_token_not_found_or_expired");
            this.$modal.show("server-error");
          } else {
            this.serverErrorMessage = this.$t("error.no_server");
            this.$modal.show("server-error");
          }
          this.$store.commit("showSpinner", false);
        } else {
          this.$router.push("/login");
          this.$store.commit("showSpinner", false);
        }
      },
    }

  };

</script>

<style lang="scss" scoped>

  #resetPassword {
    display: flex;
    flex-direction: column;
    padding: 0;
    height: 100%;
  }

  .middle {
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    .tooltip {
      cursor: pointer;
    }
  }

  .middle-container {
    background-color: white;
    padding: 40px;
    border-radius: 4px;
    width: 420px;
    display: flex;
    flex-direction: column;
  }

  .title {
    font-size: 20px;
    font-weight: bold;
    border-bottom: 1px solid #d9d9d9;
    padding-bottom: 4px;
    margin-bottom: 20px;
  }

  label {
    font-size: 16px;
  }

  input {
    margin-top: 6px;
    margin-bottom: 20px;
  }

</style>
